import { ACTION_BEGIN,
  ACTION_FAILURE,
  HIDE_ERROR
} from '../../actions/app';

import {
  FETCH_TRANSITIONS_DAT_SUCCESS,
  FETCH_TRANSITIONS_JSON_SUCCESS
} from '../../actions/transitions';

import {
  FETCH_RIGHTS_DAT_SUCCESS,
  FETCH_RIGHTS_JSON_SUCCESS
} from '../../actions/rights';

import {
  FETCH_ADMIN_STATS_DAT_SUCCESS,
  FETCH_ADMIN_STATS_JSON_SUCCESS,
} from '../../actions/adminStats';


import {
  FETCH_PROJECTS_INFO_SUCCESS
} from '../../actions/projectsInfo';

import {
  FETCH_LAST_UPDATE_INFO
} from '../../actions/lastUpdate';

import {
  FETCH_GLOBAL_ADMIN_STATS_DAT_SUCCESS,
  FETCH_GLOBAL_ADMIN_STATS_JSON_SUCCESS,
  GET_SUBSCRIPTION_INFO_SUCCESS,
  FETCH_BILLABLE_INFO_SUCCESS,
  FETCH_REPO_INFO_SUCCESS,
  FETCH_PRICE_INFO_SUCCESS,
} from '../../actions/globalAdminStats';

import {
  CHECK_IF_LOGGED_IN_BEGIN,
  CHECK_IF_LOGGED_IN_SUCCESS,
  CHECK_IF_LOGGED_IN_FAILURE,
  CHECK_IF_CAN_ACCESS_STATS_BEGIN,
  CHECK_IF_CAN_ACCESS_STATS_SUCCESS,
  CHECK_IF_CAN_ACCESS_STATS_FAILURE,
  FETCH_USERNAME_SUCCESS,
} from '../../actions/auth';

import {
  GET_IMPORT_DATA_CLIENT_SUCCESS,
  GET_IMPORT_DATA_CLIENT_WITH_TIME_PERIOD_SUCCESS,
  GET_IMPORT_DATA_ALL_SUCCESS,
  GET_IMPORT_DATA_ALL_WITH_TIME_PERIOD_SUCCESS,
  GET_IMPORT_DATA_FOR_SUBSCRIPTION_INFO_SUCCESS,
} from '../../actions/trt';

const initialState = {
  loading: false,
  errors: null,
  displayError: false,
  startedActionsCounter: 0,
};

export default function appReducer(state = initialState, action) {
  let actionsCounter = 0;

  switch (action.type) {
    case ACTION_BEGIN:
    case CHECK_IF_LOGGED_IN_BEGIN:
    case CHECK_IF_CAN_ACCESS_STATS_BEGIN:
      return {
        ...state,
        loading: true,
        errors: null,
        displayError: false,
        startedActionsCounter: state.startedActionsCounter + 1
      };
    
    case FETCH_PROJECTS_INFO_SUCCESS:
    case FETCH_LAST_UPDATE_INFO:
    case FETCH_TRANSITIONS_DAT_SUCCESS:
    case FETCH_RIGHTS_DAT_SUCCESS:
    case FETCH_ADMIN_STATS_DAT_SUCCESS:
    case FETCH_GLOBAL_ADMIN_STATS_DAT_SUCCESS:
    case FETCH_RIGHTS_JSON_SUCCESS:
    case FETCH_TRANSITIONS_JSON_SUCCESS:
    case FETCH_ADMIN_STATS_JSON_SUCCESS:
    case FETCH_GLOBAL_ADMIN_STATS_JSON_SUCCESS:
    case FETCH_USERNAME_SUCCESS:
    case CHECK_IF_LOGGED_IN_SUCCESS:
    case CHECK_IF_CAN_ACCESS_STATS_SUCCESS:
    case GET_IMPORT_DATA_CLIENT_SUCCESS:
    case GET_IMPORT_DATA_CLIENT_WITH_TIME_PERIOD_SUCCESS:
    case GET_IMPORT_DATA_ALL_SUCCESS:
    case GET_IMPORT_DATA_ALL_WITH_TIME_PERIOD_SUCCESS:
    case GET_IMPORT_DATA_FOR_SUBSCRIPTION_INFO_SUCCESS:
    case GET_SUBSCRIPTION_INFO_SUCCESS:
    case FETCH_BILLABLE_INFO_SUCCESS:
    case FETCH_REPO_INFO_SUCCESS:
    case FETCH_PRICE_INFO_SUCCESS:
      actionsCounter = state.startedActionsCounter - 1;

      return {
        ...state,
        loading: actionsCounter !== 0,
        startedActionsCounter: actionsCounter
      };

    case ACTION_FAILURE:
    case CHECK_IF_LOGGED_IN_FAILURE:
      actionsCounter = state.startedActionsCounter - 1;
      return {
        ...state,
        loading: actionsCounter !== 0,
        errorMessage: action.payload.error.message,
        displayError: true,
        startedActionsCounter: actionsCounter
      };
    case CHECK_IF_CAN_ACCESS_STATS_FAILURE:
      actionsCounter = state.startedActionsCounter - 1;
      return {
        ...state,
        loading: actionsCounter !== 0,
        errorMessage: action.payload.error.message,
        displayError: false,
        startedActionsCounter: actionsCounter
      };

    case HIDE_ERROR:
      return {
        ...state,
        displayError: false
      };

    default:
      return state;
  }
}

